import React from 'react'
import PropTypes from 'prop-types'
import { Container, Content, ContentContainer, BannerImage, RelatedArticleHeader } from './ArticleContent.style'
import SocialShare from '../SocialShare'
import { isMobile } from '../../../utils/siteHelper'
import { RELATED_ARTICLES_HEADER } from '../../../locales'

const ArticleContent = ({ featuredImage, pageURL, relatedArticles, content: { childMarkdownRemark: { html } } }) => (
  <Container>
    <ContentContainer>
      {
        featuredImage &&
        <BannerImage image={featuredImage} />
      }
      <Content
        dangerouslySetInnerHTML={{
          __html: html,
        }}
      />

      { isMobile() && <SocialShare mobileOnly pageURL={pageURL} /> }

      <RelatedArticleHeader>{RELATED_ARTICLES_HEADER}</RelatedArticleHeader>
    </ContentContainer>
  </Container>
)

ArticleContent.propTypes = {
  content: PropTypes.shape({
    childMarkdownRemark: PropTypes.shape({
      html: PropTypes.string,
    }),
  }).isRequired,
  relatedArticles: PropTypes.instanceOf(Array).isRequired,
  featuredImage: PropTypes.shape({
    fluid: PropTypes.shape(),
  }).isRequired,
  pageURL: PropTypes.string.isRequired,
}

export default ArticleContent
